import { useFormState, useForm } from 'react-final-form';

import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import Tooltip from 'components/shared/Tooltip';
import useElementBottomPosition, { SNACKBAR_POSITION } from 'hooks/useElementBottomPosition';

import { BuilderFooterButton } from '../../PageTypes/shared/BuilderFooterButton';

export default function ItinerariesItemNextButton({ id, leftChildren, isSaving }) {
  const { submit } = useForm();
  const { invalid, submitting } = useFormState();
  useElementBottomPosition(SNACKBAR_POSITION);

  return (
    <>
      <Tooltip disable={!invalid} place="top" id={'itineraries_next_button'}>
        Please complete the required fields
      </Tooltip>

      <FormActions isRight>
        {leftChildren}
        <div data-tip data-for={'itineraries_next_button'}>
          <BuilderFooterButton id={id} onClick={submit} disabled={invalid || submitting || isSaving}>
            Next
          </BuilderFooterButton>
        </div>
      </FormActions>
    </>
  );
}
